import { toast } from 'react-toastify';

export const toastOptions = { hideProgressBar: true };
const showToast = (component) => (toast(component, toastOptions));

export default showToast;
